var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "broadcast-request-viewer",
      class: { business: !!_vm.request.selectedTemplate },
    },
    [
      _c(
        "a-card",
        { staticClass: "card-container", attrs: { bordered: false } },
        [
          _c("a-card-meta", {
            staticClass: "mb-2 p-2 text-capitalize",
            attrs: {
              title: _vm.request.title,
              description: _vm.request.description,
            },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "card-summary" }, [
            _c(
              "div",
              { staticClass: "card-summary-item" },
              [
                _c("span", { staticClass: "details-subtitle" }, [
                  _vm._v(_vm._s(_vm.$t("wp.broadcast.status")) + " :"),
                ]),
                _vm._v(" "),
                _vm.request.status === "created"
                  ? _c("a-badge", { attrs: { color: "cyan", text: "Created" } })
                  : _vm._e(),
                _vm._v(" "),
                _vm.request.status === "scheduled"
                  ? _c("a-badge", {
                      attrs: { color: "volcano", text: "Scheduled" },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.request.status === "queued"
                  ? _c("a-badge", { attrs: { color: "gray", text: "Queued" } })
                  : _vm._e(),
                _vm._v(" "),
                _vm.request.status === "running"
                  ? _c("a-badge", { attrs: { color: "blue", text: "Running" } })
                  : _vm._e(),
                _vm._v(" "),
                _vm.request.status === "completed"
                  ? _c("a-badge", {
                      attrs: { color: "green", text: "Completed" },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.request.status === "failed"
                  ? _c("a-badge", { attrs: { color: "red", text: "Failed" } })
                  : _vm._e(),
                _vm._v(" "),
                _vm.request.status === "cancelled"
                  ? _c("a-badge", {
                      attrs: { color: "yellow", text: "Cancelled" },
                    })
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "card-summary-item" },
              [
                _c("span", { staticClass: "details-subtitle" }, [
                  _vm._v(_vm._s(_vm.$t("wp.broadcast.progress")) + " :"),
                ]),
                _vm._v(" "),
                _vm.request.status === "created"
                  ? _c("a-progress", {
                      directives: [
                        {
                          name: "tippy",
                          rawName: "v-tippy",
                          value: {
                            followCursor: true,
                            placement: "bottom-end",
                          },
                          expression:
                            "{ followCursor: true, placement: 'bottom-end' }",
                        },
                      ],
                      attrs: {
                        percent: _vm.getPercent(),
                        size: "small",
                        status: "normal",
                        content: _vm.getProgressText(_vm.request),
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.request.status === "scheduled"
                  ? _c("a-progress", {
                      directives: [
                        {
                          name: "tippy",
                          rawName: "v-tippy",
                          value: {
                            followCursor: true,
                            placement: "bottom-end",
                          },
                          expression:
                            "{ followCursor: true, placement: 'bottom-end' }",
                        },
                      ],
                      attrs: {
                        percent: _vm.getPercent(_vm.request),
                        size: "small",
                        status: "normal",
                        content: _vm.getProgressText(_vm.request),
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.request.status === "queued"
                  ? _c("a-progress", {
                      directives: [
                        {
                          name: "tippy",
                          rawName: "v-tippy",
                          value: {
                            followCursor: true,
                            placement: "bottom-end",
                          },
                          expression:
                            "{ followCursor: true, placement: 'bottom-end' }",
                        },
                      ],
                      attrs: {
                        percent: _vm.getPercent(_vm.request),
                        size: "small",
                        status: "normal",
                        content: _vm.getProgressText(_vm.request),
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.request.status === "running"
                  ? _c("a-progress", {
                      directives: [
                        {
                          name: "tippy",
                          rawName: "v-tippy",
                          value: {
                            followCursor: true,
                            placement: "bottom-end",
                          },
                          expression:
                            "{ followCursor: true, placement: 'bottom-end' }",
                        },
                      ],
                      attrs: {
                        percent: _vm.getPercent(_vm.request),
                        size: "small",
                        status: "active",
                        content: _vm.getProgressText(_vm.request),
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.request.status === "completed"
                  ? _c("a-progress", {
                      directives: [
                        {
                          name: "tippy",
                          rawName: "v-tippy",
                          value: {
                            followCursor: true,
                            placement: "bottom-end",
                          },
                          expression:
                            "{ followCursor: true, placement: 'bottom-end' }",
                        },
                      ],
                      attrs: {
                        percent: _vm.getPercent(_vm.request),
                        size: "small",
                        status: "success",
                        content: _vm.getProgressText(_vm.request),
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.request.status === "failed"
                  ? _c("a-progress", {
                      directives: [
                        {
                          name: "tippy",
                          rawName: "v-tippy",
                          value: {
                            followCursor: true,
                            placement: "bottom-end",
                          },
                          expression:
                            "{ followCursor: true, placement: 'bottom-end' }",
                        },
                      ],
                      attrs: {
                        percent: _vm.getPercent(_vm.request),
                        size: "small",
                        status: "exception",
                        content: _vm.getProgressText(_vm.request),
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.request.status === "cancelled"
                  ? _c("a-progress", {
                      directives: [
                        {
                          name: "tippy",
                          rawName: "v-tippy",
                          value: {
                            followCursor: true,
                            placement: "bottom-end",
                          },
                          expression:
                            "{ followCursor: true, placement: 'bottom-end' }",
                        },
                      ],
                      attrs: {
                        percent: _vm.getPercent(_vm.request),
                        size: "small",
                        status: "exception",
                        content: _vm.getProgressText(_vm.request),
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "card-summary-item" }, [
              _c("span", { staticClass: "details-subtitle" }, [
                _vm._v(_vm._s(_vm.$t("wp.broadcast.usageCost")) + " :"),
              ]),
              _vm._v(" "),
              _c("span", [
                _vm._v(" " + _vm._s(_vm.getUsageCost(_vm.request) + " ₺")),
              ]),
            ]),
            _vm._v(" "),
            ["failed", "cancelled"].includes(_vm.request.status)
              ? _c(
                  "div",
                  { staticClass: "card-summary-item" },
                  [
                    _c("span", { staticClass: "details-subtitle" }, [
                      _vm._v("Failed Reason:"),
                    ]),
                    _vm._v(" "),
                    _c("span", [_vm._v(" " + _vm._s("" + _vm.request.reason))]),
                    _vm._v(" "),
                    _c(
                      "a-button",
                      {
                        attrs: { type: "danger" },
                        on: { click: function ($event) {} },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "d-flex align-items-center justify-content-center",
                          },
                          [
                            _c("i", { staticClass: "material-icons" }, [
                              _vm._v("send"),
                            ]),
                            _vm._v(
                              "\n                        Gönderilemeyen " +
                                _vm._s(_vm.getFailedCount()) +
                                " Kişiye Yeniden Gönder\n                    "
                            ),
                          ]
                        ),
                      ]
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "card-summary-item" }, [
              _c("span", { staticClass: "details-subtitle" }, [
                _vm._v(_vm._s(_vm.$t("wp.broadcast.sendingTime")) + " :"),
              ]),
              _vm._v(" "),
              !!_vm.request.scheduleAt
                ? _c("span", [
                    _vm._v(_vm._s(_vm.scheduleAtHumanize(_vm.request))),
                  ])
                : _c("span", [
                    _vm._v(_vm._s(_vm.createdAtHumanize(_vm.request))),
                  ]),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "card-main" },
            [
              _c(
                "a-card",
                {
                  staticClass: "details-card",
                  attrs: { title: _vm.$t("wp.broadcast.customer") },
                },
                [
                  _c(
                    "div",
                    [
                      _c(
                        "a-divider",
                        {
                          staticClass: "details-subtitle",
                          attrs: { orientation: "left" },
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("wp.broadcast.phoneNumbers")) +
                              "\n                    "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "contacts" }, [
                        _c(
                          "div",
                          { staticClass: "contacts__line" },
                          _vm._l(
                            !_vm.isMoreContacts
                              ? _vm.request.customPhoneNumbers.slice(0, 3)
                              : _vm.request.customPhoneNumbers,
                            function (item) {
                              return _c(
                                "span",
                                { key: item._id, staticClass: "number" },
                                [_vm._v(_vm._s(item.number))]
                              )
                            }
                          ),
                          0
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "d-flex align-items-center flex-column mb-2",
                          },
                          [
                            !_vm.isMoreContacts &&
                            !!_vm.request &&
                            !!_vm.request.customPhoneNumbers &&
                            _vm.request.customPhoneNumbers.length > 3
                              ? _c("span", { staticClass: "mb-1" }, [
                                  _vm._v("..."),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            !!_vm.request &&
                            !!_vm.request.customPhoneNumbers &&
                            _vm.request.customPhoneNumbers.length > 3
                              ? _c(
                                  "a-button",
                                  {
                                    attrs: { type: "primary" },
                                    on: { click: _vm.showMoreContact },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        !_vm.isMoreContacts
                                          ? _vm.$t("wp.broadcast.showMore")
                                          : _vm.$t("wp.broadcast.showLess")
                                      ) + "\n                            "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  !!_vm.request &&
                  !!_vm.request.group &&
                  _vm.request.group.length > 0
                    ? _c(
                        "div",
                        [
                          _c(
                            "a-divider",
                            {
                              staticClass: "details-subtitle",
                              attrs: { orientation: "left" },
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("wp.broadcast.groupDetail")) +
                                  "\n                    "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            _vm._l(_vm.request.group, function (group) {
                              return _c("div", [
                                _c("div", [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.$t("wp.broadcast.groupName")) +
                                        " :"
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("span", [_vm._v(_vm._s(group.name))]),
                                ]),
                              ])
                            }),
                            0
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ]
              ),
              _vm._v(" "),
              _c(
                "a-card",
                { attrs: { title: _vm.$t("wp.broadcast.messages") } },
                [
                  _c(
                    "div",
                    { staticClass: "messages" },
                    [
                      _vm.request.selectedTemplate
                        ? _c("WhatsappMessagePreview", {
                            attrs: {
                              body: _vm.getTemplateParameters(
                                _vm.request.selectedTemplate
                              ).body,
                              footer: _vm.getTemplateParameters(
                                _vm.request.selectedTemplate
                              ).footer,
                              headerType: _vm.getTemplateParameters(
                                _vm.request.selectedTemplate
                              ).headerText,
                              "header-text": _vm.getTemplateParameters(
                                _vm.request.selectedTemplate
                              ).headerText,
                              buttons: _vm.getTemplateParameters(
                                _vm.request.selectedTemplate
                              ).buttons,
                            },
                          })
                        : _c(
                            "div",
                            { staticClass: "body" },
                            _vm._l(_vm.request.messages, function (message, i) {
                              return _c(
                                "div",
                                {
                                  key: message._id,
                                  staticClass: "payload-wrapper-message",
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "notallowed" },
                                    [
                                      message.type === "TEXT"
                                        ? _c("TextMessage", {
                                            staticClass: "not-allowed",
                                            attrs: {
                                              "preview-mode": true,
                                              "show-attributes": false,
                                              "show-emoji": false,
                                              disabled: true,
                                              "whatsapp-mode": false,
                                              "show-emoji-picker": false,
                                              "show-placeholder": false,
                                            },
                                            model: {
                                              value: message.text,
                                              callback: function ($$v) {
                                                _vm.$set(message, "text", $$v)
                                              },
                                              expression: "message.text",
                                            },
                                          })
                                        : message.type === "RANDOM_TEXT"
                                        ? _c("RandomTextMessage", {
                                            attrs: {
                                              texts: message.texts,
                                              "preview-mode": true,
                                              "show-attributes": false,
                                              "show-emoji": false,
                                              disabled: true,
                                              "whatsapp-mode": false,
                                              "show-emoji-picker": false,
                                              "show-placeholder": false,
                                            },
                                          })
                                        : message.type === "GALLERY"
                                        ? _c("GalleryMessageEditor", {
                                            staticClass: "not-allowed",
                                            attrs: {
                                              cards: message.cards,
                                              "preview-mode": true,
                                              "show-attributes": false,
                                              "show-emoji": false,
                                              disabled: true,
                                              "whatsapp-mode": false,
                                              "show-emoji-picker": false,
                                              "show-placeholder": false,
                                            },
                                          })
                                        : message.type === "IMAGE"
                                        ? _c("ImageBotResponse", {
                                            staticClass: "not-allowed",
                                            attrs: {
                                              "default-image-url":
                                                message.imageUrl,
                                              "default-asset-id":
                                                message.assetId,
                                              "preview-mode": true,
                                              "show-attributes": false,
                                              "show-emoji": false,
                                              disabled: true,
                                              "whatsapp-mode": false,
                                              "show-emoji-picker": false,
                                              "show-placeholder": false,
                                            },
                                          })
                                        : message.type === "BUTTON"
                                        ? _c("ButtonMessageEditor", {
                                            staticClass: "not-allowed",
                                            attrs: {
                                              "preview-mode": true,
                                              "show-attributes": false,
                                              "show-emoji": false,
                                              disabled: true,
                                              "whatsapp-mode": false,
                                              "show-emoji-picker": false,
                                              "show-placeholder": false,
                                            },
                                            model: {
                                              value: _vm.request.messages[i],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.request.messages,
                                                  i,
                                                  $$v
                                                )
                                              },
                                              expression: "request.messages[i]",
                                            },
                                          })
                                        : message.type === "QUICK_REPLY"
                                        ? _c("QuickReplyMessageEditor", {
                                            staticClass: "not-allowed",
                                            attrs: {
                                              "preview-mode": true,
                                              "show-attributes": false,
                                              "show-emoji": false,
                                              disabled: true,
                                              "whatsapp-mode": false,
                                              "show-emoji-picker": false,
                                              "show-placeholder": false,
                                            },
                                            model: {
                                              value: _vm.request.messages[i],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.request.messages,
                                                  i,
                                                  $$v
                                                )
                                              },
                                              expression: "request.messages[i]",
                                            },
                                          })
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ]
                              )
                            }),
                            0
                          ),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }